
export const stepTitles: string[] = [
  'Customer Details',
  'Property Details',
  'Product Details',
  'Decoration',
  'Photos and Drawings',
  'Signoff'
];

export const ORDER_STATUS_DRAFT = 'Draft';
export const ORDER_STATUS_QUOTE = 'Quote';
export const ORDER_STATUS_PENDING = 'Pending';
export const ORDER_STATUS_SUBMITTED = 'Submitted';
export const ORDER_STATUS_ORDER = 'Order';
export const ORDER_STATUS_SURVEYOR_PENDING = 'SurveyPending';
export const ORDER_STATUS_APPROVED = 'SurveyApproved';
export const ORDER_STATUS_REJECTED = 'SurveyRejected';
export const ORDER_STATUS_COMPLETED = 'Completed';
export const ORDER_STATUS_CANCELLED = 'Cancelled';
export const ORDER_STATUS_REMOVED_FROM_SURVEYOR = "RemovedFromSurveyor";
export const ORDER_STATUS_REMOVED_FROM_SALESREP = "RemovedFromRep";


export const SYNC_STATUS_PENDING = 'Pending';
export const SYNC_STATUS_SYNCED = 'Synced';
export const SYNC_STATUS_CONFLICT = 'Conflict';
export const SYNC_STATUS_FAILED = 'Failed';

export const SALESREP_ROLE = "sales";
export const SURVEYOR_ROLE = "surveyor";

export const WIZARD_BUTTON_NEXT_TEXT = "Next";
export const WIZARD_BUTTON_BACK_TEXT = "Back";
export const WIZARD_BUTTON_PREV_TEXT = "Previous";
export const WIZARD_BUTTON_SAVE_AND_CLOSE_TEXT = "Save & Close";
